const archeoObjectsSetup = () => {
  const components = document.querySelectorAll('[data-component-archeo-objects]');


  components.forEach((component) => {
    const flexibleContent = document.querySelector('[data-component-page-contentblocks]');
    const objects = component.querySelectorAll('.object');
    let isEverythingPositioned = false;

    const positionObjects = () => {
      const blocks = flexibleContent.children;
      const eligibleBlocks = Array.from(blocks).reduce((acc, item) => {
        const containsExplainer = item.querySelector('[data-component-explainer]');
        const isFaqBlock = item.getAttribute('data-component-article-block-faq') !== null;
        const isTitleBlock = item.getAttribute('data-component-article-block-title') !== null;
        const isGalleryBlock = item.getAttribute('data-component-article-block-gallery') !== null;
        const isButtonBlock = item.getAttribute('data-component-article-block-button') !== null;
        const isSplitBlock = item.getAttribute('data-component-article-block-split') !== null;
        const isBannerBlock = item.getAttribute('data-component-article-block-cta') !== null;
        const isLogosBlock = item.getAttribute('data-component-logo-list') !== null;
        const hasContentContainer = item.querySelector('.content-wrapper');

        if (!isTitleBlock && !isLogosBlock && !containsExplainer && hasContentContainer && !isFaqBlock && !isSplitBlock && !isButtonBlock && !isGalleryBlock && !isBannerBlock) acc.push(item);
        return acc;
      }, []);

      let objectIterationIndex = 0;

      Array.from(eligibleBlocks).forEach((block, index) => {
        if (index % 2 === 0) {
          const isOdd = objectIterationIndex % 2 === 0;
          if (objects[objectIterationIndex]) {
            block.querySelector('.content-wrapper').append(objects[objectIterationIndex]);
            objects[objectIterationIndex].style.position = 'absolute';
            objects[objectIterationIndex].style.top = '0px';
            if (!isOdd) objects[objectIterationIndex].style.right = '40px';
            if (isOdd) objects[objectIterationIndex].style.left = '40px';
            objectIterationIndex += 1;
          }
        }
      });

      if(objectIterationIndex <= objects.length - 1) {
        Array.from(objects).forEach((object, index) => {
          if(index >= objectIterationIndex) object.style.display = 'none';
        });
      }
    };

    const resetObjects = () => {
      Array.from(objects).forEach((object, index) => {
        component.querySelector('.objects-wrapper').append(object);
        object.style.position = 'static';
        object.style.display = index === 0 ? 'flex' : 'none';
      });
    };
    const handleResize = () => {
      if (flexibleContent) {
        if (window.innerWidth >= 1280) {
          if (isEverythingPositioned) return;
          positionObjects();
          isEverythingPositioned = true;
        } else {
          if (!isEverythingPositioned) return;
          resetObjects();
          isEverythingPositioned = false;
        }
      } else {
        Array.from(objects).forEach((object) => {
          object.style.display = 'none';
        });
      }
    };

    window.addEventListener('resize', () => handleResize());
    handleResize();
  });
};
archeoObjectsSetup();